/** Qual folha modal está aberta. Qualquer parte do app pode abrir uma. */
import { create } from 'zustand';
import type { Waiting } from '@quadro/domain';

export type SheetRequest =
  | { kind: 'task'; id: string }
  | { kind: 'waiting'; taskId: string; title: string; onConfirm: (w: Waiting) => void }
  | { kind: 'wip' }
  | { kind: 'settings'; tab?: 'projects' | 'themes' | 'taxonomy' }
  | { kind: 'people' }
  | { kind: 'routine'; id: string | null }
  | { kind: 'event'; id: string | null; preset?: { date?: string; start?: string; end?: string } }
  | { kind: 'map-import' }
  | { kind: 'claude' }
  | { kind: 'notifications' }
  | { kind: 'teams' }
  /** Modelos de tarefa: lista; com edit, abre o editor (null = novo); fromTask preenche a partir de uma tarefa. */
  | { kind: 'templates'; edit?: string | null; fromTask?: string };

export const useSheets = create<{ current: SheetRequest | null }>(() => ({ current: null }));
export const openSheet = (r: SheetRequest) => useSheets.setState({ current: r });
export const closeSheet = () => useSheets.setState({ current: null });
